<template>
    <!-- Modal -->
    <transition  name="modal" >
        <div ref="main" @keydown.esc="cerrar()" class="modal  modal-mask show" id="modalid" tabindex="-1" style="display:block" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div   :class="'modal-dialog modal-dialog-scrollable ' + size" role="document">
                <div class="modal-content" >
                    <div style="color:white" class="modal-header bg-modal">
                        <h5  class="modal-title">
                            <slot name="titulo"></slot>
                        </h5>
                            <button @click="cerrar()" type="button" class="close close-2" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            
                    </div>
                    <div class="modal-body">
                        <slot name="contenido"></slot>
                    </div>
                    <!-- <div class="modal-footer text-center">
                        <button type="button" @click="cerrar()" class="btn btn-outline-rosa btn-sm" data-dismiss="modal">Cerrar
                            
                        </button>
                        <slot name="botones"></slot>
                    </div> -->
                </div>
            </div>
        </div>
    </transition>
    
</template>

<script>

import { mixin as clickaway } from 'vue-clickaway';


export default {

    mixins : [ clickaway ],

    name : 'ModalComponent',

    props : [
        'size'
    ],

    data(){
        return{

        }
    },

    methods : {
        
        cerrar(){

            document.body.style.overflow = "auto";
            this.$emit('cerrar');


        }

    },

    beforeDestroy() {

        document.body.style.overflow = "auto";

    },

    created() {

        document.body.style.overflow = "hidden";

    },

    mounted() {

        this.$refs.main.focus();

    }

}
</script>

<style>
.modal-mask{
    background: rgba(0, 0, 0, 0.5);
}
</style>
